/**
 * DevExtreme (core/utils/math.js)
 * Version: 16.2.5
 * Build date: Mon Feb 27 2017
 *
 * Copyright (c) 2012 - 2017 Developer Express Inc. ALL RIGHTS RESERVED
 * EULA: https://www.devexpress.com/Support/EULAs/DevExtreme.xml
 */
"use strict";
var sign = function(value) {
    if (0 === value) {
        return 0
    }
    return value / Math.abs(value)
};
var fitIntoRange = function(value, minValue, maxValue) {
    return Math.min(Math.max(value, minValue), maxValue)
};
exports.sign = sign;
exports.fitIntoRange = fitIntoRange;



//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/devextreme/core/utils/math.js
// module id = ../../../../devextreme/core/utils/math.js
// module chunks = 3